import React from "react";
import { useNavigate } from "react-router-dom";
import PrivacyImage from '../assets/PrivacyPolicy.jpg'; // Adjust if the path is different

const Privacy_Policy = () => {
    const navigate = useNavigate();

    const handleBackToHome = () => {
        navigate("/");
    };

    return (
        <>
            {/* Header Image Section */}
            <div className="w-full bg-white rounded-md overflow-hidden">
                <div className="relative w-full h-[300px]">
                    <div
                        className="absolute inset-0 bg-cover bg-center opacity-80"
                        style={{ backgroundImage: `url(${PrivacyImage})` }}
                    ></div>

                    <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white text-center px-4">
                        <h1 className="text-3xl font-semibold">Privacy Policy for Besto HRMS</h1>
                        <button
                            onClick={handleBackToHome}
                            className="bg-gradient-to-r from-[#0d1d3c] to-[#0c3483] mt-4 px-5 py-2 hover:bg-blue-600 transition text-white rounded-md w-auto"
                        >
                            Back to Home Page
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Privacy Policy Content */}
            <div className="max-w-5xl mx-auto my-8 p-6 bg-gray-100 rounded-md shadow-md text-base leading-relaxed">
                <p className="mb-4">Effective Date: 11-05-2025
                </p>
                <p className="mb-4">
                    The following Privacy Policy governs the online information collection practices of Bestowal Systems and Services Private Limited (herein referred to as Besto HRMS) (“Besto HRMS,” “we,” or “us”). It outlines the types of information that we gather about you while you are using our website <a>https://bestohrms.com </a>and the ways in which we use this information.
                    Besto HRMS is a web-based SaaS platform that helps users who have created accounts (“User(s)”) manage HR operations and organizational processes by allowing them to collect, store, and analyze information such as candidate profiles, employee records, vendor details, and internal communication logs (“Content”). The platform may also track interactions from non-registered individuals who access shared content such as applicants, vendors, or external stakeholders (“Viewer(s)”)—collectively referred to in this document, along with our Users, as our “Service” participants.
                    We process your data in accordance with applicable laws and regulations, adhering to industry best practices.

                </p>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Purpose and Scope
                    </h2>
                    <p>The purpose of this Privacy Policy is to provide you with a transparent overview of:</p>
                    <ul className="space-y-2">
                        <ul className="ml-5 list-disc text-sm text-gray-700">
                            <li>The information we collect


                            </li>
                            <li>How we use and protect it
                            </li>
                            <li>The rights and choices you have regarding your personal data</li>
                        </ul>
                        <p>For customers of Besto HRMS, further details may be described in your customer agreement. At times, we may also provide specific notices or options to opt in or out of certain uses of your information when we collect it.
                        </p>
                        <p>
                            This Privacy Policy describes how we, as a service provider, collect and process information from both Users and Viewers of our Services. While providing services on behalf of our registered Users, we may collect Viewer-related data. The use of such data is primarily governed by our contract with the respective User and the privacy policies of their organizations.<strong>Besto HRMS is not responsible for the privacy practices of our Users or any third parties.</strong>

                        </p>
                    </ul>
                </section>
                {/* Sections */}
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Information We Collect</h2>
                    <p className="text-left">We may collect the following categories of information:
                    </p>
                    <ul className="space-y-2">
                        <li><strong>a) Personal Information</strong></li>
                        <ul className="ml-5 list-disc text-sm text-gray-700">
                            <li>Full name, email address, phone number, job title</li>
                            <li>Company or organizational affiliation
                            </li>
                            <li>Employee information including demographic details, contact data, and ID proofs
                            </li>
                            <li>Candidate data such as resumes, qualifications, and employment history
                            </li>
                            <li>Vendor data including tax IDs, registration certificates, and contact details
                            </li>
                        </ul>
                        <li className="mt-2"><strong>b. Usage and Technical Information
                        </strong></li>
                        <ul className="ml-5 list-disc text-sm text-gray-700">
                            <li>Device Information (e.g., device type, OS, app version)</li>
                            <li>IP address and geolocation
                            </li>
                            <li>Date and time of access, pages visited, and other activity logs


                            </li>
                        </ul>
                        <li className="mt-2"><strong>c. Sensitive Information (Where applicable)

                        </strong></li>
                        <ul className="ml-5 list-disc text-sm text-gray-700">
                            <li>Government-issued identification numbers


                            </li>
                            <li>Bank account details for salary disbursement



                            </li>
                            <li>Health or biometric data for compliance or verification, if authorized



                            </li>
                        </ul>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">2. How We Use Your Information</h2>
                    <p className="text-left">We use the information collected to:
                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Provide, maintain, and improve our HRMS Services


                        </li>
                        <li>Facilitate HR functions like recruitment,and communication


                        </li>
                        <li>Respond to inquiries and support requests
                        </li>
                        <li>Notify Users about updates, security alerts, and service-related information
                        </li>
                        <li>Meet legal, regulatory, and contractual obligations
                        </li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Legal Basis for Data Processing</h2>
                    <p className="text-left mb-2">We process your personal information based on:</p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Your explicit consent


                        </li>
                        <li>Performance of a contract


                        </li>
                        <li>Compliance with legal obligations


                        </li>
                        <li>Our legitimate interest in operating and improving the platform</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Data Sharing and Disclosure
                    </h2>
                    <p>
                        We may share your data under the following circumstances:
                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>With authorized personnel within your organization




                        </li>
                        <li>With third-party service providers


                        </li>
                        <li>With government or regulatory authorities when legally required





                        </li>
                        <li>Our legitimate interest in operating and improving the platform</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Data Security
                    </h2>
                    <p className="text-left">We implement appropriate administrative, technical, and physical safeguards to protect your data. These include:</p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>SSL encryption for data in transit


                        </li>
                        <li>Access control and user authentication


                        </li>
                        <li>Regular security audits and software updates


                        </li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Data Retention
                    </h2>
                    <p>
                        We retain personal information for as long as necessary to fulfill the purposes outlined in this policy or as required by law. After the retention period, data is securely deleted or anonymized.
                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">7. Your Rights

                    </h2>
                    <p className="text-left">Depending on your jurisdiction, you may have the following rights:
                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Right to access personal data we hold about you




                        </li>
                        <li>Right to correct or update your data





                        </li>
                        <li>Right to request deletion of your data


                        </li>
                        <li>
                            Right to object to or restrict certain processing



                        </li>
                        <li>
                            Right to withdraw consent at any time



                        </li>
                    </ul>
                    <p>To exercise any of these rights, please contact us at [Insert Email Address].
                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">8. Cookies and Tracking Technologies


                    </h2>
                    <p className="text-left">Our website uses cookies and similar technologies to:

                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Improve user experience







                        </li>
                        <li>Track site performance








                        </li>
                        <li>Gather analytical data





                        </li>

                    </ul>
                    <p>You may manage cookie preferences through your browser settings.

                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">9. International Transfers

                    </h2>
                    <p>
                        If you are accessing our Services from outside India, please be aware that your data may be transferred to and processed in India or other jurisdictions with different data protection standards.
                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">10. Children’s Privacy


                    </h2>
                    <p>
                        Besto HRMS is not intended for use by individuals under the age of 16. We do not knowingly collect personal data from minors. If we learn we have collected such data, we will delete it promptly.
                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">11. Updates to This Privacy Policy



                    </h2>
                    <p>
                        We may update this Privacy Policy from time to time to reflect changes in law or our practices. The most current version will always be available on our website. Continued use of our Services after changes indicates your acceptance of the revised policy.
                    </p>
                </section>
                <section className="mb-4">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">12. Contact Us</h2>
                    <p className="mb-2">If you have any questions, concerns, or complaints regarding this Privacy Policy or our data handling practices, please contact:
                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Email: <a href="mailto:contact@bestowalsystems.com/ hr@bestowalsystems.com 
" className="text-blue-500 hover:underline"></a>contact@bestowalsystems.com / hr@bestowalsystems.com
                        </li>
                        <li>Phone:+91 94055 30011
                        </li>
                        <li>Address: 2nd Floor, Office No.21, Wadhwani Plaza, Near Ambedkar chowk, Pimpri, Pune, Maharashtra, India - 411018.</li>
                    </ul>
                </section>
            </div>
        </>
    );
};

export default Privacy_Policy;
